import { TeamState } from '@/types';
import { TeamLogo } from '@/components/TeamLogo';

interface ScoreBarProps {
  teamA: TeamState;
  teamB: TeamState;
  scoreA: number;
  scoreB: number;
  servingTeamId?: string;
}

/**
 * Compact always-visible score strip shown at the top of scoring dialogs/modals.
 * When servingTeamId is provided, the serving team's score appears first.
 */
export function ScoreBar({ teamA, teamB, scoreA, scoreB, servingTeamId }: ScoreBarProps) {
  const isTeamAServing = servingTeamId === teamA.id;
  const firstTeam = isTeamAServing ? teamA : teamB;
  const secondTeam = isTeamAServing ? teamB : teamA;
  const firstScore = isTeamAServing ? scoreA : scoreB;
  const secondScore = isTeamAServing ? scoreB : scoreA;

  return (
    <div className="flex items-center justify-center gap-3 py-2 px-4 mb-3 rounded-lg bg-surface-raised border border-border">
      <div className="flex items-center gap-1.5">
        <TeamLogo team={firstTeam} size="sm" />
        <span className="text-xs font-bold uppercase" style={{ color: firstTeam.color }}>
          {firstTeam.shortName}
        </span>
      </div>
      <span className="font-mono-nums text-2xl font-bold text-text-primary">
        {firstScore}
      </span>
      <span className="text-text-muted text-lg font-bold">-</span>
      <span className="font-mono-nums text-2xl font-bold text-text-primary">
        {secondScore}
      </span>
      <div className="flex items-center gap-1.5">
        <span className="text-xs font-bold uppercase" style={{ color: secondTeam.color }}>
          {secondTeam.shortName}
        </span>
        <TeamLogo team={secondTeam} size="sm" />
      </div>
    </div>
  );
}
